import { React, useEffect, useState, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
    Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Menu,
    Accordion, AccordionSummary, AccordionDetails, CircularProgress, ListItem, ListItemText, ListItemAvatar, Avatar, Divider, Checkbox,
    Tabs, Tab
} from '@material-ui/core/';
import { DatePicker } from '@material-ui/pickers';
import { authFetch, logout } from '../../auth';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DoneIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SaveIcon from '@material-ui/icons/Save';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import CancelIcon from '@material-ui/icons/Cancel';
import UpdateIcon from '@material-ui/icons/Update';
import DateRangeIcon from '@material-ui/icons/DateRange';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import AssessmentIcon from '@material-ui/icons/Assessment';
import DataGrid from 'react-data-grid';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3,
      fontSize: 14,
      minWidth: 60,
    },
    body: {
      fontSize: 11,
      color: 'black',
      height: 30,
      backgroundColor: 'white',
      padding: 2
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    tableHeader:{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        padding: 1,
        fontSize: 14,
    },
    container: {
        maxHeight: 440,
        overflowX: "auto"
    },
    cell:{
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.primary.dark,
        padding: 1,
        fontSize: 14,
        textAlign: 'center'
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    formRow: {
        width: "80%",       
        minHeight: 19,          
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    tableTitle: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 14 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
        marginLeft: theme.spacing(1),
        minHeight: 19
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    },
    componentTitle: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.secondary.main,
        padding: theme.spacing(1),
        borderRadius: 10,
        marginBottom: theme.spacing(1)
    },
    componentPrincipalTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.light,
        padding: 2,
        border: `solid 1px ${theme.palette.secondary.dark}`,
        borderRadius: 10,
        marginBottom: theme.spacing(1)
    },
    accordionStyle:{
        backgroundColor: theme.palette.secondary.light,
        color:  theme.palette.primary.dark,
    },
    avatarStyle: {
        color: theme.palette.getContrastText(theme.palette.primary.dark),
        backgroundColor: theme.palette.primary.dark,
    },
    accordionList: {
        width: '100%',                
    },
    dividerStyle: {
        backgroundColor: theme.palette.client.contrastText
    },    
    listInputsContentStyle: {
        color:  theme.palette.primary.dark,  
        marginLeft: theme.spacing(2)      
    }
}));

export default function SUIReport (props){
    const classes = useStyles();  
    let billingDate = props.billingDate;
    const [feedbackDialog, setFeedbackDialog] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState("");
    const [expanded, setExpanded] = useState(false);
    const [suiReportState, setSuiReportState] = useState([]);
    const [reportInputs, setReportInputs] = useState([]);  
    const [reportColumns, setReportColumns] = useState([]);  
    const [processing, setProcessing] = useState(false);
    const [downloading, setDownloading] = useState(false);    
    const [downloadingFrontiers, setDownloadingFrontiers] = useState(false);
    const [marketsSubsidy, setMarketsSubsidy] = useState({});
    const [internalReportStatus, setInternalReportStatus] = useState({});

    // Estados para el nuevo Reporte de Generación por Subportafolios
    const [downloadingSubportfolios, setDownloadingSubportfolios] = useState(false);
    const [subportfolioTab, setSubportfolioTab] = useState(0);

    // Data por defecto para la Hoja 1 (Resumen Comparativo)
    const [subportfoliosRows, setSubportfoliosRows] = useState([
        { id: 1,  concepto: "Demanda Comercial",        unidad: "kW",     modelo_1: 0, modelo_4: 0 },
        { id: 2,  concepto: "Cantidad en contratos",    unidad: "kW",     modelo_1: 0, modelo_4: 0 },
        { id: 3,  concepto: "Precio de Contratos",      unidad: "$/kWh",  modelo_1: 0, modelo_4: 0 },
        { id: 4,  concepto: "Valor en Contratos",       unidad: "$",      modelo_1: 0, modelo_4: 0 },
        { id: 5,  concepto: "Compras en Bolsa",         unidad: "kW",     modelo_1: 0, modelo_4: 0 },
        { id: 6,  concepto: "Precio en Bolsa",          unidad: "$/kWh",  modelo_1: 0, modelo_4: 0 },
        { id: 7,  concepto: "Valor en Bolsa",           unidad: "$",      modelo_1: 0, modelo_4: 0 },
        { id: 8,  concepto: "Ventas en Bolsa",          unidad: "KWh",    modelo_1: 0, modelo_4: 0 },
        { id: 9,  concepto: "Precio ventas en Bolsa",   unidad: "$/KWh",  modelo_1: 0, modelo_4: 0 },
        { id: 10, concepto: "Valor ventas Bolsa $",     unidad: "$",      modelo_1: 0, modelo_4: 0 },
        { id: 11, concepto: "Cantidad ventas contratos","unidad": "KWh",    modelo_1: 0, modelo_4: 0 },
        { id: 12, concepto: "Precio ventas contratos",  unidad: "$/KWh",  modelo_1: 0, modelo_4: 0 },
        { id: 13, concepto: "Valor ventas contratos",   unidad: "$",      modelo_1: 0, modelo_4: 0 },
        { id: 14, concepto: "Componente G",             unidad: "$/kWh",  modelo_1: 0, modelo_4: 0 }
    ]);

    const subportfoliosColumns = [
        { key: 'concepto', name: 'CONCEPTO', resizable: true, width: 250 },
        { key: 'unidad', name: 'UNIDAD', resizable: true, width: 110 },
        { key: 'modelo_1', name: 'Modelo 1', resizable: true, width: 160 },
        { key: 'modelo_4', name: 'Modelo 4', resizable: true, width: 160 }
    ];

    // Data por defecto para la Hoja 2 (PBNA Techado Plano)
    const [pbnaTechadoRows, setPbnaTechadoRows] = useState([]);
    const pbnaTechadoColumns = [
        { key: 'variable', name: 'Variable', resizable: true, width: 200 },
        { key: 'fecha', name: 'FECHA', resizable: true, width: 160 },
        { key: 'hora', name: 'HORA', resizable: true, width: 140 },
        { key: 'valor', name: 'VALOR', resizable: true, width: 160 }
    ];
   
    const handlePanelChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);        
    };

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialog(true);
    };
    
    const handleFeedbackDialogClose = () => {
        setFeedbackDialog(false);
    };

    const showFeedbackDialog = () => (
        <Dialog
            open={feedbackDialog}
            onClose={handleFeedbackDialogClose}       
            className={classes.formText}            
        >
            <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>Aviso</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText>
                    {feedbackMsg}
                </DialogContentText>
            </DialogContent>
            <DialogActions>          
              <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>
                Aceptar
              </Button>
            </DialogActions>
        </Dialog>
    );
  
    const DataTable = (props) => (
      <DataGrid columns={props.columns} rows={props.rows} className={'rdg-light'} 
        style={{color: '#606B6A', height: 400, fontSize: 14}}/> 
    );

    const processReportInformation = (code, reportIdx) => (e) => {
        let uploadInfo = true;
        
        if (uploadInfo) {            
            setProcessing(true);                        
            let reportState = {...suiReportState[reportIdx]};
            reportState.Processed = true;            
            reportInputs[reportIdx].forEach((value, vidx) => reportState.Inputs[vidx].Value = value);
            delete reportState.Data;
            let opts = {                                         
                'username': props.username,   
                'period': String(billingDate.getMonth() + 1),
                'year': billingDate.getFullYear(),                
                'report_status': reportState      
            };
            authFetch(
                "/api/process-sui-report-" + code + "?user_type=" + props.userType,
                {
                    method: 'post',
                    body: JSON.stringify(opts),
                }
            ).then(r => {
                if (r.status === 422){
                    logout();
                    return null;
                }
                else if (r.status === 200){
                    return r.json();
                }
                else {
                    setFeedbackMsg('Error en el procesamiento.');
                    handleFeedbackDialogOpen();
                    setProcessing(false); 
                    return null;
                }
            })
            .then(response => {
              if (response && response.Upload === 'OK'){
                setFeedbackMsg('Reporte Procesado: ' + code);
                handleFeedbackDialogOpen();
                setProcessing(false);       
                authFetch("/api/check-billing-sui-reports?username=" + props.username +
                    "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1) + "&version=" + props.tariffCalcVersion
                ).then(response => {
                    if (response.status === 422){
                        logout();
                        return null;
                    }
                    return response.json();
                }).then(response => {
                    if (response && response.sui_reports){                        
                        let suiReportsInputs = [];                                                                                                                 
                        response.sui_reports.forEach(report => { 
                            let auxArray = []; 
                            report.Inputs.forEach(input => auxArray.push(input.Value ? input.Value : null)); 
                            suiReportsInputs.push(auxArray);
                        });    
                        let suiReportColumns = [];
                        response.sui_reports.forEach(report => {
                            let reportColNames = []; 
                            report.DataLabels.forEach(
                                (label, lidx) => { reportColNames.push({name: label, key: report.DataDbLabels[lidx], resizable: true}); }
                            ); 
                            suiReportColumns.push(reportColNames);
                        });        
                        setReportColumns([...suiReportColumns]);                                                                                                                                                                          
                        setReportInputs([...suiReportsInputs]);
                        setSuiReportState([...response.sui_reports]);                                               
                    }
                });
              }
              else {
                setFeedbackMsg('Error al procesar los datos.');
                handleFeedbackDialogOpen();
              }
            });
        }
    };

    const downloadReport = (code) => (e) => {
        let year = billingDate.getFullYear();
        let period = String(billingDate.getMonth() + 1);            
        setDownloading(true);   
        authFetch("/api/generate-format?report_type=billing" 
            + "&username=" + props.username + "&code=" + code + "&timestamp=" + new Date().toISOString().slice(0,19) +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1)
            + "&version=" + props.tariffCalcVersion + "&type=prod",
            { responseType: 'blob' }
        ).then(response => {
            if (response.status === 422){
                logout();
                return null;
            }
            else if (response.status === 200){
                return response.blob();
            }                    
        }).then(blob => {     
            if (blob) {
                let filePeriod = String(period).length <= 1 ? '0' + period : period; 
                setDownloading(false);                   
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'Reporte_Auditoria_' + code + '_' + props.username + '_' + filePeriod + '_' + year + '.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);                                    
            }
        });
    };

    // Descarga del ZIP de consumos por frontera (Acordeón 2)
    const downloadFrontierConsumptionsZip = () => {
        let year = billingDate.getFullYear();
        let period = String(billingDate.getMonth() + 1);
        let filePeriod = String(period).length <= 1 ? '0' + period : period;
        
        setDownloadingFrontiers(true);
        authFetch("/api/generate-format?report_type=billing" 
            + "&username=" + props.username 
            + "&code=consumos_frontera" 
            + "&timestamp=" + new Date().toISOString().slice(0,19)
            + "&year=" + year 
            + "&month=" + period
            + "&version=" + props.tariffCalcVersion 
            + "&type=prod",
            { responseType: 'blob' }
        ).then(response => {
            if (response.status === 422){
                logout();
                return null;
            } else if (response.status === 200){
                return response.blob();
            } else {
                setFeedbackMsg('Error al descargar los consumos por frontera.');
                handleFeedbackDialogOpen();
                setDownloadingFrontiers(false);
                return null;
            }
        }).then(blob => {
            if (blob) {
                setDownloadingFrontiers(false);
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'Consumos_Por_Frontera_' + year + filePeriod + '.zip';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }
        });
    };

    // Descarga del Reporte de Generación por Subportafolios (Acordeón 3 - Descarga Excel con 2 Hojas)
    const downloadGenerationSubportfoliosReport = () => {
        let year = billingDate.getFullYear();
        let period = String(billingDate.getMonth() + 1);
        let filePeriod = String(period).length <= 1 ? '0' + period : period;

        setDownloadingSubportfolios(true);
        authFetch(
            "/api/download-reporte-generacion-subportafolios?username=" + props.username
            + "&year=" + year
            + "&period=" + period
            + "&version=" + props.tariffCalcVersion
            + "&portfolio=" + (props.portfolio || "Ecopetrol")
            + "&subportfolios=Modelo 1,Modelo 4"
            + "&timestamp=" + new Date().toISOString().slice(0,19),
            { responseType: 'blob' }
        ).then(response => {
            if (response.status === 422){
                logout();
                return null;
            } else if (response.status === 200){
                return response.blob();
            } else {
                setFeedbackMsg('Error al descargar el Reporte de Generación por Subportafolios.');
                handleFeedbackDialogOpen();
                setDownloadingSubportfolios(false);
                return null;
            }
        }).then(blob => {
            if (blob) {
                setDownloadingSubportfolios(false);
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'Reporte_Generacion_Subportafolios_' + year + filePeriod + '.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }
        });
    };

    const addT2Garanty = () => {                
        let newGarantyInputVal = reportInputs[0].slice(0,10).map(val => null);
        let newGarantyInputObj = suiReportState[0].Inputs.slice(0,10).map(obj => ({...obj, Value: null}));
        let newT2InputVal = [...reportInputs[0], ...newGarantyInputVal];        
        let newT2InputsObj = [...suiReportState[0].Inputs, ...newGarantyInputObj];        
        let reportInputAux = reportInputs;
        reportInputAux[0] = newT2InputVal;
        setReportInputs([...reportInputAux]);
        setSuiReportState([...suiReportState], suiReportState[0].Inputs = newT2InputsObj);
    };

    const deleteT2Garanty = () => {
        let actualLength = reportInputs[0].length;                
        let reportInputsAux = reportInputs;
        reportInputsAux[0].splice(actualLength-10, 10);
        setReportInputs([...reportInputsAux]);
        let suiReportInputAux = suiReportState[0].Inputs;
        suiReportInputAux.splice(actualLength-10, 10);
        setSuiReportState([...suiReportState], suiReportState[0].Inputs = suiReportInputAux);              
    };

    const addMarketSubsidy = (market) => {        
        if (!market){
            setFeedbackMsg('Seleccione un mercado.');
            handleFeedbackDialogOpen();
        }
        else {
            market = market.split("-")[1];
            let auxMarketsSubsidy = marketsSubsidy;
            if (!(market in auxMarketsSubsidy)){
                auxMarketsSubsidy[market] = [null,null,null,null];
                setMarketsSubsidy(auxMarketsSubsidy);
            }
            else{
                setFeedbackMsg('El mercado ya fue agregado.');
                handleFeedbackDialogOpen();
            }
        }                
    };

    let principalComponent = () => (
        <Grid container spacing={1} justify="space-evenly">                            
            {/* 1. ACCORDEONES EXISTENTES DE REPORTES SUI (Formatos SUI) */}
            {
                suiReportState.map((suiState, pidx) =>(
                    <Grid key={pidx} item xs={12}>
                        <Accordion TransitionProps={{ unmountOnExit: true }} className={classes.accordionStyle} expanded={expanded === pidx} onChange={handlePanelChange(pidx)} >
                            <AccordionSummary expandIcon={<ArrowDropDownIcon color="primary"/>}>
                                <Typography>{'Formato ' + String(pidx + 1)}</Typography>
                                {
                                    suiState.Processed ? 
                                    <DoneIcon fontSize="small" color="success" style={{marginLeft:10}}/>
                                    :
                                    <HourglassFullIcon fontSize="small" color="disabled" style={{marginLeft:10}}/>                                    
                                }
                            </AccordionSummary>
                            <AccordionDetails>
                            <Grid container spacing={2} justify="space-evenly">
                                <Grid item xs={6}>                                    
                                    <Typography variant="subtitle1" color="primary">{suiState.Processed ? 'Estado: procesado': 'Estado: sin procesar'}</Typography>
                                    {
                                        suiState.Processed ? 
                                        <Typography variant="subtitle1" color="primary">{'Fecha de procesamiento: ' + suiState.ProcessingDate}</Typography>
                                        : 
                                        null
                                    }
                                </Grid>                                                                                                                
                                <Grid item xs={9}>
                                    {
                                        suiState.Inputs.length > 0 ? 
                                        <Fragment>
                                        <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Información a ingresar</Typography>
                                        <Grid container spacing={2} justify="space-evenly">
                                        {
                                            suiState.Inputs.map((input, sidx) => (
                                                <Fragment key={sidx}>                                                
                                                    {
                                                        suiState.Code === 'T2' && sidx % 10 === 0?
                                                        <Grid item xs={12}> 
                                                        <Typography variant="subtitle1" color="primary">
                                                            {'Garantía ' + String(Number(sidx/10 + 1))}
                                                        </Typography>
                                                        </Grid>
                                                        :
                                                        suiState.Code === 'T9' && sidx === 0?
                                                        <Grid container justify="space-evenly">
                                                            <Grid item xs={12}> 
                                                            <Typography variant="subtitle1" color="primary">
                                                                {'Parametrización subsidios por mercado'}
                                                            </Typography>                                           
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        null                                            
                                                    }    
                                                    {
                                                        suiState.Code === 'T9' && marketsSubsidy !== null?
                                                            sidx > 0 && sidx < 5 &&
                                                            Object.keys(marketsSubsidy).length > 0 ?
                                                            Object.keys(marketsSubsidy).map((market, midx) => (
                                                            <Grid item xs={6} key={midx}>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                                                <Fragment>                                                                            
                                                                    <Typography variant="subtitle2" color="primary">
                                                                        {input.Label + ' ' + market}
                                                                    </Typography>
                                                                    <TextField                                                                            
                                                                        size="small"                                                                            
                                                                        value={marketsSubsidy[market][sidx-1]}                                               
                                                                        InputProps={{                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                                                            classes: {                                        
                                                                                input: classes.formText
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let aux = marketsSubsidy;
                                                                            aux[market][sidx-1] = e.target.value;
                                                                            setMarketsSubsidy({...aux});
                                                                            setReportInputs([...reportInputs], reportInputs[pidx][sidx] = null);}}
                                                                        variant="outlined"
                                                                        className={classes.formRow} 
                                                                        select={input.Select}     
                                                                    >
                                                                        {
                                                                            input.Select ?                                                                                                                                                                                                                                        
                                                                            input.Values.map((value, vidx) => (
                                                                                <MenuItem key={vidx} value={value} className={classes.formItem}>{value}</MenuItem>                                                
                                                                            ))
                                                                            :
                                                                            []
                                                                        }
                                                                    </TextField>
                                                                </Fragment>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                            </Grid>
                                                         ))
                                                            :        
                                                            sidx === 0 ? 
                                                            <Fragment>                                                        
                                                            <Grid item xs={6}>
                                                            {
                                                            input.Type !== 'Date' ? 
                                                            <Fragment>                                                                            
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <TextField                                                                            
                                                                    size="small"                                                                            
                                                                    value={reportInputs[pidx][sidx]}                                               
                                                                    InputProps={{                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                                                        classes: {                                        
                                                                            input: classes.formText
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = e.target.value);}}
                                                                    variant="outlined"
                                                                    className={classes.formRow} 
                                                                    select={input.Select}     
                                                                    type={input.Type}                                                                                                                                                                                                                                                                                                                                                
                                                                >
                                                                    {
                                                                        input.Select ?                                                                                                                                                                                                                                        
                                                                        input.Values.map((value, vidx) => (
                                                                            <MenuItem key={vidx} value={value} className={classes.formItem}>{value}</MenuItem>                                                
                                                                        ))
                                                                        :
                                                                        []
                                                                    }
                                                                </TextField>
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <DatePicker           
                                                                    size="small"
                                                                    className={classes.formRow}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                    inputVariant="outlined"                                                                                                                                                                                                                                                                                                                                                            
                                                                    okLabel={""}
                                                                    cancelLabel={""}
                                                                    format="dd-MM-yyyy"
                                                                    value={reportInputs[pidx][sidx]}                                                                                                                                                                                                                                                
                                                                    onChange={(date) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = date);}}
                                                                    error={false}
                                                                    InputProps={{                                            
                                                                        classes: {
                                                                            input: classes.formText,                                    
                                                                        }
                                                                    }}
                                                                    autoOk                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                />
                                                            </Fragment>
                                                            }
                                                            </Grid>
                                                            <Grid item xs={7}>
                                                            <Button color='primary' variant='contained' startIcon={<AddIcon/>} onClick={(e) => {addMarketSubsidy(reportInputs[pidx][0]); setReportInputs([...reportInputs], reportInputs[pidx][0] = null);}}> Añadir </Button>
                                                            </Grid>
                                                            </Fragment>
                                                            :
                                                            sidx >= 5 ? 
                                                            <Fragment>
                                                            {
                                                                sidx === 5 ?
                                                                <Grid item xs={12}>
                                                                <Typography variant="subtitle1" color="primary">
                                                                    {'Parametrización de comercializador'}
                                                                </Typography>
                                                                </Grid>
                                                                :
                                                                null
                                                            }
                                                            <Grid item xs={6}>
                                                        {
                                                            input.Type !== 'Date' ? 
                                                            <Fragment>                                                                            
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <TextField                                                                            
                                                                    size="small"                                                                            
                                                                    value={sidx > 5 && reportInputs[pidx][5] ? reportInputs[pidx][5].includes('1') ? '100' : reportInputs[pidx][sidx] : reportInputs[pidx][sidx]}                                               
                                                                    InputProps={{                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                                                        classes: {                                        
                                                                            input: classes.formText
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = e.target.value); 
                                                                                     if (sidx === 5) {setReportInputs([...reportInputs], reportInputs[pidx][6] = "100");
                                                                                        setReportInputs([...reportInputs], reportInputs[pidx][7] = "100");}}}
                                                                    variant="outlined"
                                                                    className={classes.formRow} 
                                                                    select={input.Select}     
                                                                    type={input.Type}                                                                                                                                                                                                                                                                                                                                                
                                                                >
                                                                    {
                                                                        input.Select ?                                                                                                                                                                                                                                        
                                                                        input.Values.map((value, vidx) => (
                                                                            <MenuItem key={vidx} value={value} className={classes.formItem}>{value}</MenuItem>                                                
                                                                        ))
                                                                        :
                                                                        []
                                                                    }
                                                                </TextField>
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <DatePicker           
                                                                    size="small"
                                                                    className={classes.formRow}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                    inputVariant="outlined"                                                                                                                                                                                                                                                                                                                                                            
                                                                    okLabel={""}
                                                                    cancelLabel={""}
                                                                    format="dd-MM-yyyy"
                                                                    value={reportInputs[pidx][sidx]}                                                                                                                                                                                                                                                
                                                                    onChange={(date) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = date);}}
                                                                    error={false}
                                                                    InputProps={{                                            
                                                                        classes: {
                                                                            input: classes.formText,                                    
                                                                        }
                                                                    }}
                                                                    autoOk                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                />
                                                            </Fragment>
                                                        }
                                                        </Grid>
                                                        </Fragment>
                                                        :
                                                        null
                                                        :
                                                        <Grid item xs={6}>                                                        
                                                        {
                                                            input.Type !== 'Date' ? 
                                                            <Fragment>                                                                            
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <TextField                                                                            
                                                                    size="small"                                                                            
                                                                    value={reportInputs[pidx][sidx]}                                               
                                                                    InputProps={{                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                                                        classes: {                                        
                                                                            input: classes.formText
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = e.target.value);}}
                                                                    variant="outlined"
                                                                    className={classes.formRow} 
                                                                    select={input.Select}     
                                                                    type={input.Type}                                                                                                                                                                                                                                                                                                                                                
                                                                >
                                                                    {
                                                                        input.Select ?                                                                                                                                                                                                                                        
                                                                        input.Values.map((value, vidx) => (
                                                                            <MenuItem key={vidx} value={value} className={classes.formItem}>{value}</MenuItem>                                                
                                                                        ))
                                                                        :
                                                                        []
                                                                    }
                                                                </TextField>
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <Typography variant="subtitle2" color="primary">
                                                                    {input.Label}
                                                                </Typography>
                                                                <DatePicker           
                                                                    size="small"
                                                                    className={classes.formRow}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                                                    inputVariant="outlined"                                                                                                                                                                                                                                                                                                                                                            
                                                                    okLabel={""}
                                                                    cancelLabel={""}
                                                                    format="dd-MM-yyyy"
                                                                    value={reportInputs[pidx][sidx]}                                                                                                                                                                                                                                                
                                                                    onChange={(date) => {setReportInputs([...reportInputs], reportInputs[pidx][sidx] = date);}}
                                                                    error={false}
                                                                    InputProps={{                                            
                                                                        classes: {
                                                                            input: classes.formText,                                    
                                                                        }
                                                                    }}
                                                                    autoOk                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                />
                                                            </Fragment>
                                                        }
                                                        </Grid>
                                                }                                                
                                                </Fragment>
                                            ))
                                        }
                                        {
                                            suiState.Code === 'T2' ? 
                                                suiState.Inputs.length <= 10 ?
                                                <Grid item xs={4}>
                                                <Button color='primary' variant='contained' startIcon={<AddIcon/>} onClick={addT2Garanty}> Añadir </Button>
                                                </Grid>
                                                :
                                                <Fragment>
                                                <Grid item xs={4}>
                                                <Button color='primary' variant='contained' startIcon={<AddIcon/>} onClick={addT2Garanty}> Añadir </Button>
                                                </Grid>
                                                <Grid item xs={4}>
                                                <Button color='primary' variant='contained' startIcon={<ClearIcon/>} onClick={deleteT2Garanty}> Eliminar </Button>
                                                </Grid>
                                                </Fragment>
                                            :                                                                                                
                                            null
                                        }
                                        </Grid>
                                        </Fragment>
                                    :
                                        null
                                    }                                                                                                                                                                                                
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Acciones</Typography>
                                    <Grid container justify="space-evenly">
                                        <Grid item xs={4}>
                                            {
                                                processing ? 
                                                <CircularProgress color="primary"/>
                                                :
                                                <Button color='primary' disabled={!internalReportStatus['process_sui']} variant='contained' startIcon={<DonutLargeIcon/>} onClick={processReportInformation(suiState.Code, pidx)}> Procesar </Button>
                                            }
                                        </Grid>
                                        <Grid item xs={4}>
                                            {
                                                downloading ? 
                                                <CircularProgress color="primary"/>
                                                :
                                                <Button color='primary' variant='contained' startIcon={<ArrowDropDownCircleIcon/>} onClick={downloadReport('0' + String(pidx+1))}> Descargar </Button>
                                            }                                                                                                                                                                
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Datos procesados</Typography>
                                    {
                                        <DataTable columns={reportColumns[pidx]} rows={suiState.Data}/>                                                 
                                    }
                                </Grid>                                                                           
                            </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>                                        
                ))
            }

            {/* 2. ACCORDEÓN RECUPERADO: CONSUMOS POR FRONTERA */}
            <Grid item xs={12}>
                <Accordion TransitionProps={{ unmountOnExit: true }} className={classes.accordionStyle} expanded={expanded === 'consumos_frontera'} onChange={handlePanelChange('consumos_frontera')}>
                    <AccordionSummary expandIcon={<ArrowDropDownIcon color="primary"/>}>
                        <Typography>Consumos por frontera</Typography>
                        <DoneIcon fontSize="small" color="primary" style={{marginLeft: 10}}/>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2} justify="space-evenly">
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" color="primary">
                                    Descarga de consumos horarios (energía activa, reactiva inductiva, reactiva capacitiva y penalidades) organizados en archivos independientes por código SIC y frontera dentro de un archivo comprimido ZIP.
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Acciones</Typography>
                                <Grid container justify="center">
                                    <Grid item xs={4} style={{textAlign: 'center'}}>
                                        {
                                            downloadingFrontiers ? 
                                            <CircularProgress color="primary"/>
                                            :
                                            <Button 
                                                color='primary' 
                                                variant='contained' 
                                                startIcon={<ArrowDropDownCircleIcon/>} 
                                                onClick={downloadFrontierConsumptionsZip}
                                            > 
                                                Descargar ZIP
                                            </Button>
                                        }                                                                                
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>

            {/* 3. NUEVO ACCORDEÓN: REPORTE DE GENERACIÓN POR SUBPORTAFOLIOS (MODELO 1 vs MODELO 4) */}
            <Grid item xs={12}>
                <Accordion TransitionProps={{ unmountOnExit: true }} className={classes.accordionStyle} expanded={expanded === 'generacion_subportafolios'} onChange={handlePanelChange('generacion_subportafolios')}>
                    <AccordionSummary expandIcon={<ArrowDropDownIcon color="primary"/>}>
                        <Typography>Reporte Generación por Subportafolios (Modelo 1 vs Modelo 4)</Typography>
                        <AssessmentIcon fontSize="small" color="primary" style={{marginLeft: 10}}/>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2} justify="space-evenly">
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" color="primary">
                                    Balance comparativo de compra y venta de energía en contratos y bolsa, precios ponderados y Componente G ($/kWh) por subportafolio. El archivo descargado contiene la hoja comparativa y la hoja de PBNA techado horario.
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Acciones</Typography>
                                <Grid container justify="center">
                                    <Grid item xs={4} style={{textAlign: 'center'}}>
                                        {
                                            downloadingSubportfolios ? 
                                            <CircularProgress color="primary"/>
                                            :
                                            <Button 
                                                color='primary' 
                                                variant='contained' 
                                                startIcon={<ArrowDropDownCircleIcon/>} 
                                                onClick={downloadGenerationSubportfoliosReport}
                                            > 
                                                Descargar Excel
                                            </Button>
                                        }                                                                                
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={11}>
                                <Tabs 
                                    value={subportfolioTab} 
                                    onChange={(e, val) => setSubportfolioTab(val)} 
                                    indicatorColor="primary" 
                                    textColor="primary"
                                    style={{marginBottom: 10}}
                                >
                                    <Tab label="Comparativo Modelos" />
                                    <Tab label="PBNA Techado Horario" />
                                </Tabs>

                                {subportfolioTab === 0 ? (
                                    <Fragment>
                                        <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Hoja 1: Resumen Comparativo</Typography>
                                        <DataTable columns={subportfoliosColumns} rows={subportfoliosRows}/>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <Typography variant="subtitle1" className={classes.componentPrincipalTitle}>Hoja 2: PBNA Techado por Fecha/Hora</Typography>
                                        <DataTable columns={pbnaTechadoColumns} rows={pbnaTechadoRows}/>
                                    </Fragment>
                                )}
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </Grid>  
    );

    useEffect (() => {
        document.title = "Reportes SUI";  
        authFetch("/api/check-billing-sui-reports?username=" + props.username +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1) + "&version=" + props.tariffCalcVersion
        ).then(response => {
            if (response.status === 422){
                logout();
                return null;
            }
            return response.json();
        }).then(response => {
            if (response && response.sui_reports){                        
                let suiReportsInputs = [];                                                                                                                 
                response.sui_reports.forEach(report => { 
                    let auxArray = []; 
                    report.Inputs.forEach(input => auxArray.push(input.Value ? input.Value : null)); 
                    suiReportsInputs.push(auxArray);
                });    
                let suiReportColumns = [];
                response.sui_reports.forEach(report => {
                    let reportColNames = []; 
                    report.DataLabels.forEach(
                        (label, lidx) => { reportColNames.push({name: label, key: report.DataDbLabels[lidx], resizable: true}); }
                    ); 
                    suiReportColumns.push(reportColNames);
                });
                
                const operationColumns = [
                    { name: 'Fecha Operación', key: 'fecha_operacion' },
                    { name: 'Frontera', key: 'frontera' },
                    { name: 'Version', key: 'version' },
                    { name: 'AH1', key: 'ah1' }, { name: 'AH2', key: 'ah2' }, { name: 'AH3', key: 'ah3' }, { name: 'AH4', key: 'ah4' },
                    { name: 'AH5', key: 'ah5' }, { name: 'AH6', key: 'ah6' }, { name: 'AH7', key: 'ah7' }, { name: 'AH8', key: 'ah8' },
                    { name: 'AH9', key: 'ah9' }, { name: 'AH10', key: 'ah10' }, { name: 'AH11', key: 'ah11' }, { name: 'AH12', key: 'ah12' },
                    { name: 'AH13', key: 'ah13' }, { name: 'AH14', key: 'ah14' }, { name: 'AH15', key: 'ah15' }, { name: 'AH16', key: 'ah16' },
                    { name: 'AH17', key: 'ah17' }, { name: 'AH18', key: 'ah18' }, { name: 'AH19', key: 'ah19' }, { name: 'AH20', key: 'ah20' },
                    { name: 'AH21', key: 'ah21' }, { name: 'AH22', key: 'ah22' }, { name: 'AH23', key: 'ah23' }, { name: 'AH24', key: 'ah24' },
                    { name: 'RH1', key: 'rh1' }, { name: 'RH2', key: 'rh2' }, { name: 'RH3', key: 'rh3' }, { name: 'RH4', key: 'rh4' },
                    { name: 'RH5', key: 'rh5' }, { name: 'RH6', key: 'rh6' }, { name: 'RH7', key: 'rh7' }, { name: 'RH8', key: 'rh8' },
                    { name: 'RH9', key: 'rh9' }, { name: 'RH10', key: 'rh10' }, { name: 'RH11', key: 'rh11' }, { name: 'RH12', key: 'rh12' },
                    { name: 'RH13', key: 'rh13' }, { name: 'RH14', key: 'rh14' }, { name: 'RH15', key: 'rh15' }, { name: 'RH16', key: 'rh16' },
                    { name: 'RH17', key: 'rh17' }, { name: 'RH18', key: 'rh18' }, { name: 'RH19', key: 'rh19' }, { name: 'RH20', key: 'rh20' },
                    { name: 'RH21', key: 'rh21' }, { name: 'RH22', key: 'rh22' }, { name: 'RH23', key: 'rh23' }, { name: 'RH24', key: 'rh24' },
                    { name: 'CH1', key: 'ch1' }, { name: 'CH2', key: 'ch2' }, { name: 'CH3', key: 'ch3' }, { name: 'CH4', key: 'ch4' },
                    { name: 'CH5', key: 'ch5' }, { name: 'CH6', key: 'ch6' }, { name: 'CH7', key: 'ch7' }, { name: 'CH8', key: 'ch8' },
                    { name: 'CH9', key: 'ch9' }, { name: 'CH10', key: 'ch10' }, { name: 'CH11', key: 'ch11' }, { name: 'CH12', key: 'ch12' },
                    { name: 'CH13', key: 'ch13' }, { name: 'CH14', key: 'ch14' }, { name: 'CH15', key: 'ch15' }, { name: 'CH16', key: 'ch16' },
                    { name: 'CH17', key: 'ch17' }, { name: 'CH18', key: 'ch18' }, { name: 'CH19', key: 'ch19' }, { name: 'CH20', key: 'ch20' },
                    { name: 'CH21', key: 'ch21' }, { name: 'CH22', key: 'ch22' }, { name: 'CH23', key: 'ch23' }, { name: 'CH24', key: 'ch24' }
                ];  
                const auditColumns = [
                    { name: 'Fecha Facturación', key: 'fechafacturacion' },
                    { name: 'Versión', key: 'version' },
                    { name: 'ID Factura', key: 'factura_id' },
                    { name: 'Frontera', key: 'frontera' },
                    { name: 'Factura DIAN', key: 'factura_dian' },
                    { name: 'Nombre Cliente', key: 'nombre_cliente' },
                    { name: 'Municipio ID', key: 'municipio' },
                    { name: 'Nombre Municipio', key: 'nombre_municipio' },
                    { name: 'Nombre Departamento', key: 'nombre_departamento' },
                    { name: 'Sigla OR', key: 'sigla_or' },
                    { name: 'Operador Red', key: 'operador_red' },
                    { name: 'Nivel de Tensión', key: 'nivel_de_tension' },
                    { name: 'Consumo Activa', key: 'cantidad_consumo_activa' },
                    { name: 'Consumo Inductiva', key: 'cantidad_consumo_inductiva' },
                    { name: 'Consumo Ind. Penalizada', key: 'cantidad_consumo_inductiva_penalizada' },
                    { name: 'Consumo Capacitiva', key: 'cantidad_consumo_capacitiva' },
                    { name: 'Consumo Cap. Penalizada', key: 'cantidad_consumo_capacitiva_penalizada' },
                    { name: 'Consumo Reactiva Penalizada', key: 'cantidad_consumo_reactiva_penalizada' },
                    { name: 'Factor M', key: 'factor_m' },
                    { name: 'Precio Comp. G', key: 'precio_componente_g' },
                    { name: 'Precio Comp. R', key: 'precio_componente_r' },
                    { name: 'Precio Comp. C', key: 'precio_componente_c' },
                    { name: 'Precio Comp. D', key: 'precio_componente_d' },
                    { name: 'Precio Comp. O', key: 'precio_componente_o' },
                    { name: 'Precio Pond. Comp. P', key: 'precio_ponderado_componente_p' },
                    { name: 'Precio Pond. Comp. T', key: 'precio_ponderado_componente_t' },
                    { name: 'Valor Comp. G', key: 'valor_componente_g' },
                    { name: 'Valor Comp. R', key: 'valor_componente_r' },
                    { name: 'Valor Comp. C', key: 'valor_componente_c' },
                    { name: 'Valor Comp. D', key: 'valor_componente_d' },
                    { name: 'Valor Comp. O', key: 'valor_componente_o' },
                    { name: 'Valor Comp. P', key: 'valor_componente_p' },
                    { name: 'Valor Comp. T', key: 'valor_componente_t' },
                    { name: 'Valor Consumo Activa', key: 'valor_consumo_activa' },
                    { name: 'Valor Reactiva Penalizada', key: 'valor_consumo_reactiva_penalizada' },
                    { name: 'Valor Consumo Energía', key: 'valor_consumo_energia' },
                    { name: 'Ajuste Comp. G', key: 'valor_componente_g_ajuste' },
                    { name: 'Ajuste Comp. R', key: 'valor_componente_r_ajuste' },
                    { name: 'Ajuste Comp. C', key: 'valor_componente_c_ajuste' },
                    { name: 'Ajuste Comp. D', key: 'valor_componente_d_ajuste' },
                    { name: 'Ajuste Comp. O', key: 'valor_componente_o_ajuste' },
                    { name: 'Ajuste Comp. P', key: 'valor_componente_p_ajuste' },
                    { name: 'Ajuste Comp. T', key: 'valor_componente_t_ajuste' },
                    { name: 'Ajuste Consumo Activa', key: 'valor_consumo_activa_ajuste' },
                    { name: 'Ajuste Reactiva Penalizada', key: 'valor_consumo_reactiva_penalizada_ajuste' },
                    { name: 'Ajuste Consumo Energía', key: 'valor_consumo_energia_ajuste' },
                    { name: 'Comp. G Ajustado', key: 'valor_componente_g_ajustado' },
                    { name: 'Comp. R Ajustado', key: 'valor_componente_r_ajustado' },
                    { name: 'Comp. C Ajustado', key: 'valor_componente_c_ajustado' },
                    { name: 'Comp. D Ajustado', key: 'valor_componente_d_ajustado' },
                    { name: 'Comp. O Ajustado', key: 'valor_componente_o_ajustado' },
                    { name: 'Comp. P Ajustado', key: 'valor_componente_p_ajustado' },
                    { name: 'Comp. T Ajustado', key: 'valor_componente_t_ajustado' },
                    { name: 'Consumo Activa Ajustado', key: 'valor_consumo_activa_ajustado' },
                    { name: 'Reactiva Penalizada Ajustada', key: 'valor_consumo_reactiva_penalizada_ajustado' },
                    { name: 'Consumo Energía Ajustado', key: 'valor_consumo_energia_ajustado' },
                    { name: 'Valor Contribución', key: 'valor_contribucion' },
                    { name: 'Contribución Otros Meses', key: 'valor_contribucion_otros_meses' },
                    { name: 'Valor Sobretasa', key: 'valor_sobretasa' },
                    { name: 'Ajuste a la Decena', key: 'valor_ajuste_a_la_decena' },
                    { name: 'Alumbrado Público', key: 'valor_impuesto_alumbrado_publico' },
                    { name: 'Ajuste Alumbrado Público', key: 'valor_impuesto_alumbrado_publico_ajuste' },
                    { name: 'Retefuente Renta', key: 'valor_retefuente_renta' },
                    { name: 'Autoretefuente Esp. Renta', key: 'valor_autoretefuente_especial_renta' },
                    { name: 'Retefuente ICA', key: 'valor_retefuente_ica' },
                    { name: 'Auto Retefuente ICA', key: 'valor_auto_retefuente_ica' },
                    { name: 'Retefuente Sobretasa Bomberil', key: 'valor_retefuente_sobretasa_bomberil' },
                    { name: 'Ajustes Cargos Regulados', key: 'valor_ajustes_cargos_regulados' },
                    { name: 'Valor Neto Factura', key: 'valor_neto_factura' },
                    { name: 'Valor Compensación', key: 'valor_compensacion' },
                    { name: 'Autoretefuente Sobre. Bomberil', key: 'valor_autoretefuente_sobretasa_bomberil' },
                    { name: 'Tipo Factura', key: 'tipo_factura' },
                    { name: 'Impuesto Seguridad', key: 'valor_impuesto_seguridad' },
                    { name: 'Ajuste Impuesto Seguridad', key: 'valor_impuesto_seguridad_ajuste' },
                    { name: 'Saldo Cartera', key: 'valor_saldo_cartera' },
                    { name: 'Amortización Desc. Financiera', key: 'valor_amortización_descuento_financiera' },
                    { name: 'Amortización Capital', key: 'valor_amortización_capital' },
                    { name: 'Total Saldo Cartera', key: 'valor_total_saldo_cartera' },
                    { name: 'Empresa', key: 'empresa' }
                ];  
                setReportColumns([operationColumns, auditColumns]);                                                                                                                                                             
                setReportInputs([...suiReportsInputs]);
                setSuiReportState([...response.sui_reports]);                                               
            }
        });

        authFetch("/api/check-internal-reports-status?username=" + String(props.username) +
            "&year=" + billingDate.getFullYear() + "&month=" + String(billingDate.getMonth() + 1)
            + "&version=" + props.tariffCalcVersion
        ).then(response => {
            if (response.status === 422){
                logout();
                return null;
            }
            return response.json();
        }).then(response => {
            if (response && response.reports_status){                    
                setInternalReportStatus(response.reports_status);                                          
            }
        });
    }, [props.billingDate]);

    return (
        <div className={classes.root}>            
            <Grid container justify="space-evenly">
                <Zoom in timeout={800}>
                    <Grid item xs={12}>      
                        {showFeedbackDialog()}                                                                                                                                                                                        
                        <Fragment>
                            <Typography variant="subtitle1" className={classes.sectionTitle}>
                                Listado de informes
                            </Typography>
                            {principalComponent()}
                        </Fragment>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                    </Grid>            
                </Zoom>
            </Grid>
        </div>
    );
}